import { computed, inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { StorageService } from '../services/storage.service';

interface CompanyContextState {
  companyId:      string | null;
  companyName:    string | null;
  companyLogoUrl: string | null;
}

const emptyState: CompanyContextState = {
  companyId:      null,
  companyName:    null,
  companyLogoUrl: null,
};

function persistable(state: CompanyContextState): CompanyContextState {
  return {
    companyId:      state.companyId,
    companyName:    state.companyName,
    companyLogoUrl: state.companyLogoUrl ?? null,
  };
}

export const CompanyContextStore = signalStore(
  { providedIn: 'root' },

  withState<CompanyContextState>(() => {
    try {
      const raw = sessionStorage.getItem('metis_company_context');
      if (raw) return persistable(JSON.parse(raw) as CompanyContextState);
    } catch { /* ignore */ }
    return emptyState;
  }),

  withComputed((store) => ({
    isInContext: computed(() => store.companyId() !== null),
  })),

  withMethods((store, storage = inject(StorageService)) => ({
    enter(companyId: string, companyName: string, companyLogoUrl: string | null = null): void {
      const next = { companyId, companyName, companyLogoUrl };
      patchState(store, next);
      storage.saveCompanyContext(next);
    },
    setLogoUrl(companyLogoUrl: string | null): void {
      const companyId   = store.companyId();
      const companyName = store.companyName();
      if (!companyId || !companyName) return;
      const next = { companyId, companyName, companyLogoUrl };
      patchState(store, { companyLogoUrl });
      storage.saveCompanyContext(next);
    },
    exit(): void {
      patchState(store, emptyState);
      storage.clearCompanyContext();
    },
  })),
);
